@if (showCompactScoreboardEvent()) {
    <ms-event-header-scoreboard
        [event]="event"
        [media]="media"
        [showParticipantImage]="showParticipantImage"
        [state]="state"
        [tracking]="tracking"
        (getToggle)="toggle()" />
} @else {
    <ms-event-header
        [isEventNameALink]="isEventNameALink"
        [event]="event"
        [isOutrightMarket]="isOutrightMarket"
        [eventUrl]="eventUrl"
        [media]="media"
        [isAllBetsButtonVisible]="isAllBetsButtonVisible"
        [state]="state"
        [tracking]="tracking"
        (getToggle)="toggle()" />
}

@if (!state?.collapsed) {
    @if (optionGroups.length) {
        @for (optionGroup of optionGroups; track optionGroup.id) {
            <ms-option-panel
                [optionGroup]="optionGroup"
                [event]="event"
                [tracking]="trackingSource"
                [thresholds]="config.optionCollapseSize"
                [collapsed]="collapsed(optionGroup)"
                [toggleable]="isMarketGroupToggable"
                [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                [optionGroupLinkable]="isOptionGroupLinkable"
                [betDetails]="betDetails"
                [hideMarketHeader]="hideOptionPanelHeaderForPriceBoost"
                [marketLogoShow]="true"
                [showHelp]="true"
                [calendarTitle]="tracking.calendarTitle"
                [sourceOfPick]="sourceOfPick"
                [isBorderHidden]="false"
                (collapsedChange)="collapsedChanged(optionGroup)" />
        }
    } @else {
        <div class="empty-panel">
            <ms-error severity="info" [message]="sitecore.eventGrid.NonGridableEmpty" [links]="false" />
        </div>
    }
    <ng-template #empty>
        <div class="empty-panel">
            <ms-error severity="info" [message]="sitecore.eventGrid.NonGridableEmpty" [links]="false" />
        </div>
    </ng-template>
}
